 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"components-Assistenza-vue":"components-Assistenza-vue","components-BaseRace-vue":"components-BaseRace-vue","components-BoxServizi-vue":"components-BoxServizi-vue","components-Card-vue":"components-Card-vue","components-Classifica-vue":"components-Classifica-vue","views-IframeRace-vue":"views-IframeRace-vue","views-Race-vue":"views-Race-vue","components-DownloadCertificate-vue":"components-DownloadCertificate-vue","components-Iscriviti-vue":"components-Iscriviti-vue","components-LavoraConNoi-vue":"components-LavoraConNoi-vue","components-LinkedRace-vue":"components-LinkedRace-vue","components-ListaIscritti-vue":"components-ListaIscritti-vue","components-Location-vue":"components-Location-vue","components-RichiestaContatto-vue":"components-RichiestaContatto-vue","components-Services-vue":"components-Services-vue","components-VerificaIscrizione-vue":"components-VerificaIscrizione-vue","lang-cs-json":"lang-cs-json","lang-de-json":"lang-de-json","lang-es-json":"lang-es-json","lang-fr-json":"lang-fr-json","lang-it-json":"lang-it-json","pages-ChiSiamo-vue":"pages-ChiSiamo-vue","pages-Contatti-vue":"pages-Contatti-vue","pages-CookiePolicy-vue":"pages-CookiePolicy-vue","pages-LavoraConNoi-vue":"pages-LavoraConNoi-vue","pages-PrivacyPolicy-vue":"pages-PrivacyPolicy-vue","pages-Servizi-vue":"pages-Servizi-vue","plugins-LodashPlugin-vue":"plugins-LodashPlugin-vue","views-404-vue":"views-404-vue","views-Circuiti-vue":"views-Circuiti-vue","views-Home-vue":"views-Home-vue","views-IframeVerificaIscritti-vue":"views-IframeVerificaIscritti-vue","views-Lang-vue":"views-Lang-vue"}[chunkId]||chunkId) + "." + {"components-Assistenza-vue":"b75bcbea","components-BaseRace-vue":"ec88bc6b","components-BoxServizi-vue":"7b9f6e51","components-Card-vue":"66409e5a","components-Classifica-vue":"4cb88856","views-IframeRace-vue":"8764556d","views-Race-vue":"2b16dc21","components-DownloadCertificate-vue":"b42726ea","components-Iscriviti-vue":"4454c898","components-LavoraConNoi-vue":"3c31601a","components-LinkedRace-vue":"5f7015bf","components-ListaIscritti-vue":"670e342e","components-Location-vue":"de7dcd71","components-RichiestaContatto-vue":"d7f9dd05","components-Services-vue":"7dd1a3c8","components-VerificaIscrizione-vue":"bad389f5","lang-cs-json":"1554abe0","lang-de-json":"1ef5aa8a","lang-es-json":"7affa352","lang-fr-json":"5e0dca43","lang-it-json":"11695ef8","pages-ChiSiamo-vue":"d46d5c90","pages-Contatti-vue":"3c9cc005","pages-CookiePolicy-vue":"483ebb32","pages-LavoraConNoi-vue":"6ced143a","pages-PrivacyPolicy-vue":"47dd3489","pages-Servizi-vue":"1664c686","plugins-LodashPlugin-vue":"4385fd77","views-404-vue":"e6db747b","views-Circuiti-vue":"d816460c","views-Home-vue":"59fae77c","views-IframeVerificaIscritti-vue":"c49c4b64","views-Lang-vue":"8579c7cf"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"views-Race-vue":1,"components-Iscriviti-vue":1,"views-Home-vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"components-Assistenza-vue":"components-Assistenza-vue","components-BaseRace-vue":"components-BaseRace-vue","components-BoxServizi-vue":"components-BoxServizi-vue","components-Card-vue":"components-Card-vue","components-Classifica-vue":"components-Classifica-vue","views-IframeRace-vue":"views-IframeRace-vue","views-Race-vue":"views-Race-vue","components-DownloadCertificate-vue":"components-DownloadCertificate-vue","components-Iscriviti-vue":"components-Iscriviti-vue","components-LavoraConNoi-vue":"components-LavoraConNoi-vue","components-LinkedRace-vue":"components-LinkedRace-vue","components-ListaIscritti-vue":"components-ListaIscritti-vue","components-Location-vue":"components-Location-vue","components-RichiestaContatto-vue":"components-RichiestaContatto-vue","components-Services-vue":"components-Services-vue","components-VerificaIscrizione-vue":"components-VerificaIscrizione-vue","lang-cs-json":"lang-cs-json","lang-de-json":"lang-de-json","lang-es-json":"lang-es-json","lang-fr-json":"lang-fr-json","lang-it-json":"lang-it-json","pages-ChiSiamo-vue":"pages-ChiSiamo-vue","pages-Contatti-vue":"pages-Contatti-vue","pages-CookiePolicy-vue":"pages-CookiePolicy-vue","pages-LavoraConNoi-vue":"pages-LavoraConNoi-vue","pages-PrivacyPolicy-vue":"pages-PrivacyPolicy-vue","pages-Servizi-vue":"pages-Servizi-vue","plugins-LodashPlugin-vue":"plugins-LodashPlugin-vue","views-404-vue":"views-404-vue","views-Circuiti-vue":"views-Circuiti-vue","views-Home-vue":"views-Home-vue","views-IframeVerificaIscritti-vue":"views-IframeVerificaIscritti-vue","views-Lang-vue":"views-Lang-vue"}[chunkId]||chunkId) + "." + {"components-Assistenza-vue":"31d6cfe0","components-BaseRace-vue":"31d6cfe0","components-BoxServizi-vue":"31d6cfe0","components-Card-vue":"31d6cfe0","components-Classifica-vue":"31d6cfe0","views-IframeRace-vue":"31d6cfe0","views-Race-vue":"c03af0fc","components-DownloadCertificate-vue":"31d6cfe0","components-Iscriviti-vue":"c03af0fc","components-LavoraConNoi-vue":"31d6cfe0","components-LinkedRace-vue":"31d6cfe0","components-ListaIscritti-vue":"31d6cfe0","components-Location-vue":"31d6cfe0","components-RichiestaContatto-vue":"31d6cfe0","components-Services-vue":"31d6cfe0","components-VerificaIscrizione-vue":"31d6cfe0","lang-cs-json":"31d6cfe0","lang-de-json":"31d6cfe0","lang-es-json":"31d6cfe0","lang-fr-json":"31d6cfe0","lang-it-json":"31d6cfe0","pages-ChiSiamo-vue":"31d6cfe0","pages-Contatti-vue":"31d6cfe0","pages-CookiePolicy-vue":"31d6cfe0","pages-LavoraConNoi-vue":"31d6cfe0","pages-PrivacyPolicy-vue":"31d6cfe0","pages-Servizi-vue":"31d6cfe0","plugins-LodashPlugin-vue":"31d6cfe0","views-404-vue":"31d6cfe0","views-Circuiti-vue":"31d6cfe0","views-Home-vue":"4f4c6552","views-IframeVerificaIscritti-vue":"31d6cfe0","views-Lang-vue":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
